interface Props {
  [key: string]: any
}

export default function MinimizeIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 17 18" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        clipRule="evenodd"
        d="M15 8H9V2L11 4L15 0L17 2L13 6L15 8Z"
        fill="#605D5D"
        fillRule="evenodd"
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        clipRule="evenodd"
        d="M2.05371 9.0119L8.0536 9.0477L8.0178 15.0476L6.02977 13.0357L2.00597 17.0118L0.0179443 14.9999L4.04174 11.0238L2.05371 9.0119Z"
        fill="#605D5D"
        fillRule="evenodd"
      />
    </svg>
  )
}
